import {
  ArrowDownLeft,
  ArrowLeftRight,
  ArrowUpRight,
  X,
  Charged,
  Refund,
  FeesCheck,
  CashCard,
  WalletAdd,
  SendIcon,
  refresh,
  EmptyTransaction,
  Managebenificary,
  Authrization,
  Pending,
  Reversal,
  Clearing,
} from "./../Public/assets";
import { useCallback, useEffect, useState } from "react";
import { SUPPORT_EMAIL } from "./Contant";

const {
  emailRegex2,
  usernameRegex,
  validationPatterns,
} = require("./../validation");

const validateUserName = (value) => {
  if (!value) return "User name is required";

  if (value.includes("@")) {
    if (!emailRegex2.test(value)) {
      return "Please enter a valid email address";
    }
  } else {
    if (!usernameRegex.test(value)) {
      return "Username must be at least 3 alphanumeric characters";
    }
  }

  return "";
};
const validateConfirmPassword = (value, password) => {
  if (!value) return "Password is required field";
  if (value !== password) return "Passwords do not match";
  return "";
};

const validationRules = {
  firstName: {
    required: "First Name is required",
    pattern: {
      regex: validationPatterns?.firstName,
      message: "First Name should be min 3 character and no special character.",
    },
  },
  lastName: {
    required: "Last Name is required",
    pattern: {
      regex: validationPatterns?.lastName,
      message: "Last Name should be min 1 character and no special character.",
    },
  },
  mobileNumber: {
    required: "Mobile Number is required",
    pattern: {
      regex: validationPatterns?.mobileNumber,
      message: "Mobile Number must have 10 digits",
    },
    // transform: (value) => `+91${value}`, // Optional transformation
  },
  pan: {
    required: "PAN Number is required",
    pattern: {
      regex: validationPatterns?.pan,
      message: "Must be a valid PAN number",
    },
  },
  panNumber: {
    required: "PAN Number is required",
    pattern: {
      regex: validationPatterns?.pan,
      message: "Must be a valid PAN number",
    },
  },
  address: {
    required: "Address is required",
  },
  city: {
    required: "City is required",
  },
  state: {
    required: "State is required",
  },
  postcode: {
    required: "Pin Code is required",
    pattern: {
      regex: validationPatterns?.panNumber,
      message: "Pin Code must have 6 digits",
    },
  },
  dob: {
    required: "DOB is required ",
    validate: (value) => {
      // Ensure user is at least 18 years old
      const selectedDate = new Date(value);
      const eighteenYearsAgo = new Date();
      eighteenYearsAgo.setFullYear(eighteenYearsAgo.getFullYear() - 18);

      if (selectedDate > eighteenYearsAgo) {
        return "You must be at least 18 years old";
      }

      return "";
    },
  },
};

const validateField = (fieldName, value) => {
  const rules = validationRules[fieldName];
  // No validation rules for the field
  if (!rules) return "";

  if (rules.required && !value) {
    return rules.required;
  }

  if (rules.pattern && !rules.pattern.regex.test(value)) {
    return rules.pattern.message;
  }

  return "";
};
// Date formater

function formatDateToYMD(isoDate) {
  const date = new Date(isoDate);
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
}

function formatDateToShort(date) {
  const options = { day: "numeric", month: "short", year: "2-digit" };
  return new Date(date).toLocaleDateString("en-GB", options).replace(",", "");
}

function reFormatDate(inputDate) {
  // Parse the input date
  const date = new Date(inputDate);

  // Extract year, month, and day
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");

  // Return formatted date
  return `${day}-${month}-${year}`;
}

function formatDateTime(date) {
  const optionsTime = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZoneName: "short",
  };

  const formattedTime = new Date(date).toLocaleTimeString("en-GB", optionsTime);

  return ` ${formattedTime}`;
}

const useDebounce = (callback, delay) => {
  const [timeoutId, setTimeoutId] = useState(null);

  const debouncedCallback = useCallback(
    (...args) => {
      // Clear previous timeout
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Set a new timeout
      const newTimeoutId = setTimeout(() => {
        callback(...args);
      }, delay);

      // Save the new timeout ID
      setTimeoutId(newTimeoutId);
    },
    [callback, delay, timeoutId]
  );

  useEffect(() => {
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [timeoutId]);

  return debouncedCallback;
};

const filterFields = (fields) =>
  fields.filter(
    (field) =>
      !field.fieldName
        ?.toLowerCase()
        .match(
          /\bfirst_name\b|\blast_name\b|\bcity\b|\bstate\b|\bstreet_address\b|\bpostcode\b|\bpayment_method\b|\bentity_type\b|\bCurrency\b|\btransfer_method\b|\bcountry_code\b|\baccount_currency\b|\bbank_country_code\b|\baccount_name\b/
        ) && field.required === true
  );

const filterAddressFields = (fields) =>
  fields.filter(
    (field) =>
      field.displayName
        ?.toLowerCase()
        .match(
          /\bpostalcode\b|\bstate\b|\bcity\b|\baddress\b|\bstreet_address\b|\bpostcode\b/
        )
    // \bpostcode\b
    // .match(/\b(postalcode|state|city|address|street_address|postcode)\b/)
  );

const lottieOptions = (animationData) => ({
  loop: true,
  autoplay: true,
  animationData,
  rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
});

const transactionTypes = {
  CONVERSION: "CONVERSION",
  FUND_RECEIVED: "FUND_RECEIVED",
  FEES: "FEES",
  WALLET_TRANSFER: "FUND_TRANSFER",
  TRANSACTION: "TRANSFER",
  CHARGE: "CHARGE",
  REFUND: "REFUND",
  // CARD_SPEND: "CARD_SPEND",
  // CARD_LOAD: "CARD_LOAD",

  // have to Verify
  CLEARING: "CLEARING",
  PENDING: "PENDING",
  AUTHORIZATION: "AUTHORIZATION",
  REVERSAL: "REVERSAL",
};


const getIcon = ({ type }) => {
  switch (type) {
    case transactionTypes.CLEARING:
      return (
        <img src={Clearing} alt="Borderless Instant" className="w-6 h-6" />
      );
    case transactionTypes.PENDING:
      return (
        <img src={Pending} alt="Borderless Instant" className="w-3.5 h-3.5" />
      );
    case transactionTypes.AUTHORIZATION:
      return (
        <img src={Authrization} alt="Borderless Instant" className="w-5 h-5" />
      );
    case transactionTypes.REVERSAL:
      return (
        <img src={Reversal} alt="Borderless Instant" className="w-6 h-6" />
      );
    case transactionTypes.TRANSACTION:
      return (
        <img
          src={ArrowUpRight}
          alt="Borderless Instant"
          className="w-3.5 h-3.5"
        />
      );
    case transactionTypes.CHARGE:
      return <img src={Charged} alt="Borderless Instant" className="w-6 h-6" />;
    case transactionTypes.FUND_RECEIVED:
      return (
        <img
          src={ArrowDownLeft}
          alt="Borderless Instant"
          className="w-3.5 h-3.5"
        />
      );
    case transactionTypes.CONVERSION:
      return (
        <img
          src={ArrowLeftRight}
          alt="Borderless Instant"
          className="w-4 h-4"
        />
      );
    case transactionTypes.FEES:
      return (
        <img src={FeesCheck} alt="Borderless Instant" className="w-6 h-6" />
      );
    case transactionTypes.WALLET_TRANSFER:
      return (
        <img
          src={ArrowLeftRight}
          alt="Borderless Instant"
          className="w-4 h-4"
        />
      );
    case transactionTypes.REFUND:
      return <img src={Refund} alt="Borderless Instant" className="w-6 h-6" />;
    case transactionTypes.CARD_SPEND:
      return <img src={ArrowUpRight} alt="Card Spend" className="w-4 h-4" />;
    case transactionTypes.CARD_LOAD:
      return <img src={WalletAdd} alt="Card Load" className="w-6 h-6" />;
    default:
      return <img src={X} alt="default" className="w-4 h-4" />;
  }
};

const formatBackendDate = (dateStr) => {
  if (!dateStr) return "";
  const [year, month, day] = dateStr?.split("-");
  return new Date(year, month - 1, day);
};

function formatCurrency(amount) {
  const options = {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  };

  const formatter = new Intl.NumberFormat(undefined, options);

  return formatter.format(amount);
}
const getInitials = (name) => {
  if (!name) return "";
  const words = name.split(" ");
  return (
    words[0]?.[0]?.toUpperCase() + words[words.length - 1]?.[0]?.toUpperCase()
  );
};

const clearSession = () => {
  sessionStorage.clear();
};

const removeUnderscores = (fieldName) => {
  return fieldName.replace(/_/g, " ");
};

const getFeeLabel = (remarks) => {
  const normalized = (remarks || "").toLowerCase();
  if (normalized.includes("deposit")) return "Deposit Fee";
  if (normalized.includes("transfer")) return "Transfer Fee";
  return "Transaction fees";
};

const CHARGE_PURPOSE_LABELS = {
  "emi bounce charges": "EMI Bounce Charge",
  "emi deduction": "EMI Deduction",
};

const formatChargePurpose = (purpose) => {
  if (!purpose || typeof purpose !== "string") return "";
  const trimmed = purpose.trim();
  const mapped = CHARGE_PURPOSE_LABELS[trimmed.toLowerCase()];
  if (mapped) return mapped;

  return trimmed
    .split(/\s+/)
    .map((word) =>
      word === word.toUpperCase()
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    )
    .join(" ");
};

const getParentTransactionNo = (transaction, transactions = []) => {
  if (transaction?.transaction_type !== "FEES") return null;

  const feeLabel = getFeeLabel(transaction?.transaction_remarks);
  if (feeLabel !== "Deposit Fee" && feeLabel !== "Transfer Fee") return null;

  const referenceId = transaction?.transaction_transaction_reference_id;
  if (!referenceId) return null;

  const parent = transactions.find(
    (item) => item?.transaction_transaction_id === referenceId,
  );
  return parent?.transaction_transaction_no || null;
};

export {
  getFeeLabel,
  getParentTransactionNo,
  formatChargePurpose,
  validateUserName,
  validateConfirmPassword,
  validationRules,
  validateField,
  formatDateToYMD,
  useDebounce,
  filterFields,
  filterAddressFields,
  lottieOptions,
  formatDateToShort,
  formatDateTime,
  reFormatDate,
  transactionTypes,
  getIcon,
  formatBackendDate,
  formatCurrency,
  getInitials,
  clearSession,
  removeUnderscores,
};

// Gmail web compose URL, pre-filled with recipient and subject.
// (mailto: links need a default mail app and cannot open in a new tab.)
export const buildSupportEmailUrl = (beneficiary) => {
  const subject = `Beneficiary verification${
    beneficiary?.nameOfBeni ? ` - ${beneficiary.nameOfBeni}` : ""
  }`;

  return `https://mail.google.com/mail/?view=cm&fs=1&to=${encodeURIComponent(
    SUPPORT_EMAIL
  )}&su=${encodeURIComponent(subject)}`;
};
